import React, { FunctionComponent } from 'react';
import { IMeetingAvatarProps } from './types';
import { Link } from 'react-router-dom';
import slugify from 'react-slugify';
import { CircularAvatar } from '../../../CustomAvatar';

export const MeetingAvatar: FunctionComponent<IMeetingAvatarProps> = ({ meeting, provided, navigateOnClick }) => {
  return (
    <Link
      to={`/meeting-dashboard/${meeting.id}/${slugify(meeting.title, {
        delimiter: '-',
      })}`}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      ref={provided.innerRef}
    >
      <CircularAvatar
        src={meeting.image}
        title={meeting.title}
        color={meeting.color}
        size="25"
        textSizeRatio={3}
        classes="img-fluid mr-05"
      />
      <span>{meeting.title}</span>
    </Link>
  );
};
